import { useState } from "react"
import { Tables } from "../../Objects/Table/Tables"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import i18next from "i18next"

export const useCreateTable = () => {
  const [Id, setIdTable] = useState<string>("-1")

  const [numberTable, setNumberTable] = useState<string>("0")

  const [description, setDescription] = useState<string>("")

  const [Status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [table, setTables] = useState<Tables | null>(null)

  const handleIdTableChange = (e: React.ChangeEvent<HTMLInputElement>) => setIdTable(e.target.value)
  const handleNumberTableChange = (e: React.ChangeEvent<HTMLInputElement>) => setNumberTable(e.target.value)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (table: Tables | null | undefined) => {
    if (table) {
      setTables(table)
      setNumberTable(table.number.toString())
      setDescription(table.description ?? "")
      setIdTable(table.id.toString())
      setStatus(table.status)
    }
  }

  const handleSubmitForm = (): Tables | { errors: ValidationError[] } => {
    const errors: ValidationError[] = []

    if (numberTable.trim().length === 0) {
      errors.push({ field: i18next.t("tables:field_number"), message: i18next.t("tables:error_invalid_number") })
    }

    if (description.trim().length > 200) {
      errors.push({
        field: i18next.t("tables:field_description"),
        message: i18next.t("tables:error_invalid_description"),
      })
    }

    if (errors.length > 0) {
      return { errors }
    }

    return new Tables({
      id: table?.id || -1,
      number: Number(numberTable),
      description: description.trim(),
      status: Status,
    })
  }

  return {
    Id,
    Number: numberTable,
    Description: description,
    Status,
    table,
    handleIdTableChange,
    handleNumberTableChange,
    handleDescriptionChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
